module.exports = __webpack_public_path__ + "static/media/reset-icon.1c87b478.svg";